<template>
  <div class="md-small-hide">
    <b-container fluid class="moow-footer mini">
      <!-- <img :src="moowLogo" class="footer-logo-holder"/>
      <md-divider class="moow-divider fat"></md-divider>-->
      <b-row>
        <b-col>
          <p class="footer-nav-item">MOOWLE | info@moowle.com | +372 5366 6903</p>
        </b-col>
        <b-col>
          <p style="float:right">
            <a
              class="footer-nav-item"
              href="https://moowle.com/terms-of-use/"
              target="_blank"
            >Terms of use |</a>
            <a
              class="footer-nav-item"
              href="https://moowle.com/privacy-policy/"
              target="_blank"
            >Privacy Policy</a>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "footer-mini",
  components: {},
  validator: null,
  data() {
    return {
      showTerms: false,
      showSnackbar: false,
      snackbarMessage: "",
      showContactForm: false
    };
  },
  computed: {
    moowLogo() {
      return require("../../assets/logos/moowle-logo-white.png");
    },
    listIcon() {
      return require("../../assets/icons/list_blue.svg");
    },
    connectIcon() {
      return require("../../assets/icons/connect_blue.svg");
    },
    peaceIcon() {
      return require("../../assets/icons/peace_blue.svg");
    },
    interImg() {
      return require("../../assets/images/interior_l1.jpg");
    },
    filterButtonText() {
      if (this.filterHasInput()) return "Find";
      else return "Scroll down";
    }
  },
  created() {},
  mounted() {
    //console.log("route.name:", this.$route.name)
    //if(this.$route.name != "listing")
    this.createHubspotChat();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    createHubspotChat() {
      try {
        let hubspotChatScript = document.createElement("script");
        hubspotChatScript.setAttribute("src", "//js.hs-scripts.com/6931050.js");
        hubspotChatScript.setAttribute("id", "hs-script-loader");
        document.body.appendChild(hubspotChatScript);
      } catch (error) {
      }
    },

    openContactUsForm() {
      this.showContactForm = true;
    },
    closeContactUsForm(isSuccess) {
      this.showContactForm = false;
      if (isSuccess) this.notifyUser("Thank You. We will be in touch promptly");
      else
        this.notifyUser("Something is not right, contact support@moowle.com");
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listings-view.css";
@import "../../assets/styles/portal.css";
</style>


// WEBPACK FOOTER //
// src/components/footer/FooterMini.vue